module.exports = __webpack_public_path__ + "img/album06_01.ab9d0ca2.jpg";